export default __webpack_public_path__ + "static/MFSDAE-fd9b2802a6875ec38f84d0635ee8cab8.png";